export type Middleware = {
  request?: (
    url: RequestInfo | URL,
    init?: RequestInit,
  ) => Promise<[RequestInfo | URL, RequestInit | undefined]> | [RequestInfo | URL, RequestInit | undefined];
  response?: (response: Response) => Promise<Response> | Response;
  error?: (error: any) => Promise<any> | any;
};

export async function applyRequestMiddlewares(
  middlewares: Middleware[],
  url: RequestInfo | URL,
  init?: RequestInit,
): Promise<[RequestInfo | URL, RequestInit | undefined]> {
  return middlewares.reduce<Promise<[RequestInfo | URL, RequestInit | undefined]>>(
    async (acc, middleware) => {
      const [currentUrl, currentInit] = await acc;
      if (middleware.request) {
        return middleware.request(currentUrl, currentInit);
      }
      return [currentUrl, currentInit];
    },
    Promise.resolve<[RequestInfo | URL, RequestInit | undefined]>([url, init]),
  );
}

export async function applyResponseMiddlewares(middlewares: Middleware[], response: Response): Promise<Response> {
  return middlewares.reduce<Promise<Response>>(async (acc, middleware) => {
    let currentResponse = await acc;
    if (middleware.response) {
      currentResponse = await middleware.response(currentResponse);
    }
    return currentResponse;
  }, Promise.resolve(response));
}

export async function applyErrorMiddlewares(middlewares: Middleware[], error: any): Promise<any> {
  return middlewares
    .reduce<Promise<any>>(async (acc, middleware) => {
      let currentError = await acc;
      if (middleware.error) {
        currentError = await middleware.error(currentError);
      }
      return currentError;
    }, Promise.resolve(error)) // Start with the resolved error
    .catch((err) => {
      // Handle the final error after all middleware processing
      throw err;
    });
}
